import React from 'react';
import { LegalSinglePage } from './Legal';

const Terms = () => <LegalSinglePage kind="terms" />;

export default Terms;
